/**
 * SelectBox Component.
 * Its Wrapper Component for Kepler `Select` Component for Single Selection.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormField from 'kepler/lib/components/FormField';
import Select from 'kepler/lib/components/Select';
import { WEBFORM_ERRORS, SELECT_BOX_OPTIONS } from '../../constants/PropTypesShapes';

class SelectBox extends Component {
  // Set the Field Settings and Error as States.
  constructor(props) {
    super(props);

    this.state = {
      options: props.options,
      errors: [],
    };
  }

  // Every Component Re-render with New Props.
  // This will update the Field Settings and validate according to the prop change during Topic Tree Selection.
  componentWillReceiveProps(props) {
    const {
      validate,
      options: { value },
    } = props;

    this.setState({
      options: props.options,
      errors: [],
    });

    if (validate === true) {
      this.validate(value);
    }
  }

  // Handle during Change Event.
  handleChange(value) {
    this.validate(value);
    this.setFormState();
  }

  // Send the Field State to Form.
  setFormState() {
    const options = this.state.options;
    this.props.handleValue(options);
  }

  // Check, If Field Value is not selected.
  isEmpty(value) {
    const isNotSelected = value === '' || value === this.props.options.options[0].value;
    return this.props.options.isRequired && isNotSelected;
  }

  // Validate Field Value and Update the State.
  validate(value) {
    const errors = [];
    const options = this.props.options;

    if (this.isEmpty(value)) {
      errors.push(this.props.errorWarn.required);
      options.hasError = true;
      options.value = '';
    } else {
      options.hasError = false;
      options.value = value;
    }

    this.setState({
      options,
      errors,
    });
  }

  // Render the `SelectBox` Component.
  render() {
    return (
      <FormField>
        <Select
          id={this.props.options.id}
          placeholder={this.props.options.options[0].value}
          value={this.state.options.value}
          options={this.state.options.options}
          onChange={(value) => this.handleChange(value)}
          errors={this.state.errors}
        />
      </FormField>
    );
  }
}

// SelectBox Props Types.
SelectBox.propTypes = {
  validate: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  options: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.shape(SELECT_BOX_OPTIONS),
    name: PropTypes.string,
    isRequired: PropTypes.bool,
    value: PropTypes.string,
    hasError: PropTypes.bool,
  }),
  handleValue: PropTypes.func.isRequired,
  errorWarn: PropTypes.shape(WEBFORM_ERRORS),
};

// SelectBox Props default values.
SelectBox.defaultProps = {
  validate: false,
  options: {},
  errorWarn: {},
};

export default SelectBox;
